import { useEffect } from "react";
import { motion } from "framer-motion";
import { EMBLEM_URL } from "@/data/content";

const Intro = ({ onComplete }) => {
  useEffect(() => {
    const timer = setTimeout(onComplete, 2000);
    const skip = () => onComplete();
    window.addEventListener("keydown", skip);
    return () => {
      clearTimeout(timer);
      window.removeEventListener("keydown", skip);
    };
  }, [onComplete]);

  return (
    <motion.div
      data-testid="intro-overlay"
      onClick={onComplete}
      className="fixed inset-0 z-[100] flex cursor-pointer flex-col items-center justify-center bg-[#0A0B0D]"
      exit={{ opacity: 0, transition: { duration: 0.4, ease: "easeOut" } }}
    >
      <motion.div
        initial={{ opacity: 0, scale: 0.5 }}
        animate={{ opacity: [0, 0.75, 0.4], scale: 1 }}
        transition={{ duration: 1.3, times: [0, 0.45, 1], ease: "easeOut" }}
        className="absolute h-[70vmin] w-[70vmin] rounded-full"
        style={{
          background:
            "radial-gradient(circle, rgba(229,46,46,0.4) 0%, rgba(255,85,0,0.12) 42%, transparent 70%)",
        }}
      />
      <motion.img
        src={EMBLEM_URL}
        alt="Arsenal Forge emblem"
        data-testid="intro-emblem"
        initial={{ opacity: 0, scale: 0.82, filter: "blur(14px)" }}
        animate={{ opacity: 1, scale: 1, filter: "blur(0px)" }}
        transition={{ delay: 0.3, duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
        className="relative w-36 sm:w-48"
      />
      <div className="mt-8 overflow-hidden">
        <motion.p
          initial={{ y: "115%", opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.95, duration: 0.55, ease: [0.16, 1, 0.3, 1] }}
          className="font-display text-2xl font-bold uppercase tracking-[0.4em] text-white sm:text-3xl"
        >
          Arsenal Forge
        </motion.p>
      </div>
      <motion.div
        initial={{ scaleX: 0 }}
        animate={{ scaleX: 1 }}
        transition={{ delay: 1.05, duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
        className="mt-4 h-px w-40 origin-center bg-[#E52E2E]"
      />
    </motion.div>
  );
};

export default Intro;
